import { heroStats, updateTicker } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full min-h-[600px] md:min-h-[680px] flex flex-col">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20cinematic%20abstract%20collage%20of%20a%20glowing%20theater%20screen%20and%20dramatic%20stage%20light%20beams%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20film%20grain%20texture%2C%20atmospheric%20dark%20background%2C%20editorial%20mood&width=1920&height=1080&seq=shenma-hero-01&orientation=landscape"
            alt="神马电影网首屏背景：影院银幕与舞台光束的抽象画面"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
        </div>

        <div className="relative z-10 w-full flex-1 flex flex-col justify-center px-4 md:px-8 pt-28 md:pt-32 pb-16 md:pb-24">
          <div className="w-full max-w-6xl mx-auto animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium">
              <i className="ri-fire-line" aria-hidden="true"></i>
              什么电影好看 · 热门推荐与高分整理
            </span>

            <h1 className="mt-5 font-heading font-black text-background-50 text-3xl sm:text-4xl md:text-6xl leading-tight md:leading-[1.15] max-w-3xl">
              神马电影网：把「什么电影好看」<br className="hidden md:block" />一页说清楚
            </h1>

            <p className="mt-5 max-w-2xl text-background-200 text-sm md:text-lg leading-relaxed">
              这里汇总热门推荐、高分电影、豆瓣高分与口碑电影，按类型筛选、按榜单排序、按年代翻片单，
              让你在几分钟内从「不知道看什么」到「今晚就它了」。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#explore"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compasses-2-line text-lg" aria-hidden="true"></i>
                按类型开始选片
              </a>
              <a
                href="#douban"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 text-background-50 font-medium whitespace-nowrap border border-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                <i className="ri-bar-chart-box-line text-lg" aria-hidden="true"></i>
                查看豆瓣高分榜
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-5 max-w-3xl">
              {heroStats.map((stat) => (
                <div key={stat.id} className="border-l-2 border-primary-500/70 pl-3">
                  <dd className="font-heading font-bold text-2xl md:text-3xl text-background-50">
                    {stat.value}
                    <span className="text-sm font-normal text-background-200 ml-1">{stat.unit}</span>
                  </dd>
                  <dt className="text-xs md:text-sm text-background-200 mt-1">{stat.label}</dt>
                </div>
              ))}
            </dl>
          </div>
        </div>

        <div className="relative z-10 w-full border-t border-background-50/15 bg-foreground-950/55 backdrop-blur-sm">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-3 flex items-center gap-3">
            <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-medium text-accent-300 whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" aria-hidden="true"></span>
              实时更新
            </span>
            <div className="marquee-wrap flex-1 overflow-hidden">
              <div className="flex w-max animate-marquee-x">
                {[...updateTicker, ...updateTicker].map((text, idx) => (
                  <span
                    key={`${text}-${idx}`}
                    className="text-xs md:text-sm text-background-200 whitespace-nowrap pr-10"
                  >
                    {text}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}